import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const getSaasLoginUrl = () => {
  const envUrl = import.meta.env.VITE_SAAS_URL;
  if (envUrl) return `${envUrl}/login`;
  const { protocol, hostname, port } = window.location;
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return `${protocol}//saas.localhost${port ? `:${port}` : ""}/login`;
  }
  return `${protocol}//saas.esg.datacaffe.ai/login`;
};

const StickyMobileCTA = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > window.innerHeight * 0.8);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.3, ease: "easeOut" }}
          className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-white/95 dark:bg-[#0f172a]/95 backdrop-blur-xl border-t border-gray-200/80 dark:border-slate-700 shadow-2xl"
          style={{ paddingBottom: 'env(safe-area-inset-bottom, 12px)' }}
        >
          <div className="flex gap-2 px-4 pt-3 pb-2">
            <button
              onClick={() => window.open("https://meetings-na2.hubspot.com/datacaffe-ai/esgcaffe-discovery-call", "_blank")}
              className="flex-1 bg-gradient-to-r from-blue-600 to-blue-700 text-white font-semibold py-3.5 rounded-xl text-sm shadow-lg"
            >
              Book a Demo
            </button>
            <a
              href={getSaasLoginUrl()}
              className="flex-1 bg-gray-100 dark:bg-slate-700 text-gray-900 dark:text-slate-200 font-semibold py-3.5 rounded-xl text-sm text-center"
            >
              Sign In
            </a>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default StickyMobileCTA;
